import { createSlice } from "@reduxjs/toolkit";
import { confirmDelivery } from "../../apis/dispense/confirmDelivery";

const initialState = {
	loading: false,
	data: null,
	error: null
}

const confirmDeliverySlice = createSlice({
	name: 'confirmDelivery',
	initialState,

	extraReducers: (builder) => {
		builder.addCase(confirmDelivery.pending.type, (state) => {
			return {
				...state,
				loading: true,
				data: null,
				error: null
			}
		})

		builder.addCase(confirmDelivery.fulfilled.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			}
		})

		builder.addCase(confirmDelivery.rejected.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: null,
				error: action.payload
			}
		})
	}

})

export default confirmDeliverySlice.reducer